import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../Unit.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { EmptyIterator_instanceqrxhm096rah7 as EmptyIterator_instance } from '../collections/CollectionsKt.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../hacks.mjs';
import { ConstrainedOnceSequence3d7vfvt49occh as ConstrainedOnceSequence } from './sequenceJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function generateSequence(seed, nextFunction) {
  var tmp;
  if (seed == null) {
    tmp = EmptySequence_instance;
  } else {
    tmp = new (GeneratorSequence())(() => seed, nextFunction);
  }
  return tmp;
}
function generateSequence_0(nextFunction) {
  return constrainOnce(new (GeneratorSequence())(nextFunction, (it) => nextFunction()));
}
function emptySequence() {
  return EmptySequence_instance;
}
var DropTakeSequenceClass;
function DropTakeSequence() {
  if (DropTakeSequenceClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'DropTakeSequence');
    DropTakeSequenceClass = $;
  }
  return DropTakeSequenceClass;
}
var TakeSequence$iterator$1Class;
function TakeSequence$iterator$1() {
  if (TakeSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.kl_1 = this$0.nl_1;
        this.ll_1 = this$0.ml_1.p1();
      }
      r1() {
        if (this.kl_1 === 0)
          throw NoSuchElementException().t6();
        this.kl_1 = this.kl_1 - 1 | 0;
        return this.ll_1.r1();
      }
      q1() {
        return this.kl_1 > 0 && this.ll_1.q1();
      }
    }
    initMetadataForClass($);
    TakeSequence$iterator$1Class = $;
  }
  return TakeSequence$iterator$1Class;
}
var TakeSequenceClass;
function TakeSequence() {
  if (TakeSequenceClass === VOID) {
    class $ {
      constructor(sequence, count) {
        this.ml_1 = sequence;
        this.nl_1 = count;
        // Inline function 'kotlin.require' call
        if (!(this.nl_1 >= 0)) {
          var message = 'count must be non-negative, but was ' + this.nl_1 + '.';
          throw IllegalArgumentException().o2(toString(message));
        }
      }
      u3(n) {
        return n >= this.nl_1 ? this : new (TakeSequence())(this.ml_1, n);
      }
      p1() {
        return new (TakeSequence$iterator$1())(this);
      }
    }
    initMetadataForClass($, 'TakeSequence', VOID, VOID, [DropTakeSequence()]);
    TakeSequenceClass = $;
  }
  return TakeSequenceClass;
}
var EmptySequenceClass;
function EmptySequence() {
  if (EmptySequenceClass === VOID) {
    class $ {
      p1() {
        return EmptyIterator_instance;
      }
      u3(n) {
        return EmptySequence_instance;
      }
    }
    initMetadataForObject($, 'EmptySequence', VOID, VOID, [DropTakeSequence()]);
    EmptySequenceClass = $;
  }
  return EmptySequenceClass;
}
var EmptySequence_instance;
function EmptySequence_getInstance() {
  return EmptySequence_instance;
}
function calcNext($this) {
  $this.ol_1 = $this.pl_1 === -2 ? $this.ql_1.rl_1() : $this.ql_1.sl_1(ensureNotNull($this.ol_1));
  $this.pl_1 = $this.ol_1 == null ? 0 : 1;
}
var GeneratorSequence$iterator$1Class;
function GeneratorSequence$iterator$1() {
  if (GeneratorSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.ql_1 = this$0;
        this.ol_1 = null;
        this.pl_1 = -2;
      }
      r1() {
        if (this.pl_1 < 0) {
          calcNext(this);
        }
        if (this.pl_1 === 0)
          throw NoSuchElementException().t6();
        var tmp = this.ol_1;
        var result = !(tmp == null) ? tmp : THROW_CCE();
        this.pl_1 = -1;
        return result;
      }
      q1() {
        if (this.pl_1 < 0) {
          calcNext(this);
        }
        return this.pl_1 === 1;
      }
    }
    initMetadataForClass($);
    GeneratorSequence$iterator$1Class = $;
  }
  return GeneratorSequence$iterator$1Class;
}
var GeneratorSequenceClass;
function GeneratorSequence() {
  if (GeneratorSequenceClass === VOID) {
    class $ {
      constructor(getInitialValue, getNextValue) {
        this.rl_1 = getInitialValue;
        this.sl_1 = getNextValue;
      }
      p1() {
        return new (GeneratorSequence$iterator$1())(this);
      }
    }
    initMetadataForClass($, 'GeneratorSequence');
    GeneratorSequenceClass = $;
  }
  return GeneratorSequenceClass;
}
function constrainOnce(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ConstrainedOnceSequence()) {
    tmp = _this__u8e3s4;
  } else {
    tmp = new (ConstrainedOnceSequence())(_this__u8e3s4);
  }
  return tmp;
}
//region block: init
EmptySequence_instance = new (EmptySequence())();
//endregion
//region block: exports
export {
  DropTakeSequence as DropTakeSequence18qfczyunxcax,
  TakeSequence as TakeSequencecj2mz1r3ww35,
  emptySequence as emptySequence25zpp7hgtqwdd,
  generateSequence as generateSequence118suk3hffuuw,
  generateSequence_0 as generateSequence3b5pkcqrpr2fo,
};
//endregion

//# sourceMappingURL=Sequences.mjs.map
